export default __webpack_public_path__ + "static/media/SmallLogo.3e73eecb.png";